import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="header-container">
      <h1>Our Menu</h1>
      <div className="underline"></div>
    </div>
  );
};

export default Header;
